import { RowCrudStatus } from "../../common/types";
import { EsignatureWebhookEvent } from "../../../api/graphql";
import { LangStore } from "../../../store";

export type EsignatureWebhookEventValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  processedAt: Date | null;
  error: string;
};

export type EsignatureWebhookEventErrorsType = {
  processedAt?: { message: string; fieldLabel: string };
  error?: { message: string; fieldLabel: string };
};

export function EsignatureWebhookEventValuesInit(): EsignatureWebhookEventValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    processedAt: null,
    error: "",
  };
}

export type EsignatureWebhookEventType =
  | EsignatureWebhookEvent
  | EsignatureWebhookEventValuesType;

export function esignatureWebhookEventDisplayId(
  source: Partial<EsignatureWebhookEvent>,
  _langStore: LangStore
) {
  return (
    (source.eventType ?? _langStore.emptyStringSymbol) +
    " - " +
    (source.externalEventId ?? _langStore.emptyStringSymbol)
  );
}

export function getEsignatureWebhookEventValues(
  source: EsignatureWebhookEventType,
  _langStore: LangStore,
  _duplicated: boolean = false
): EsignatureWebhookEventValuesType {
  const entityValues = EsignatureWebhookEventValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : esignatureWebhookEventDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.processedAt = source.processedAt
    ? new Date(source.processedAt)
    : null;
  entityValues.error = source.error || "";
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
